// const baseUrl = "https://claircius-backend.vercel.app"
const baseUrl = "https://canvas-oppluent-uvcx.vercel.app"
// const baseUrl = "http://localhost:5000"

export const APIS = {
    searchPixabay: `${baseUrl}/searchPixabay`,
    generateQR: `${baseUrl}/generateQR`,
    searchMLS: `${baseUrl}/mlsSearch`,
    sendRegistrationEmail: `${baseUrl}/send-registeration-mail`
}